import { Inject, Injectable } from '@angular/core';
import { Auth } from '@freelancer/auth';
import { Datastore } from '@freelancer/datastore';
import type { UsersSelfCollection } from '@freelancer/datastore/collections';
import {
  NATIVE_LANGUAGE_COOKIE,
  WEBAPP_LANGUAGE_COOKIE,
} from '@freelancer/localization';
import { Pwa } from '@freelancer/pwa';
import { Tracking } from '@freelancer/tracking';
import {
  ServiceWorker,
  ServiceWorkerPlugin,
} from 'capacitor-plugin-service-worker';
import { CookieService } from 'ngx-cookie';

@Injectable()
export class LanguageSwitcher {
  constructor(
    private auth: Auth,
    private cookies: CookieService,
    private datastore: Datastore,
    private tracking: Tracking,
    private pwa: Pwa,
    @Inject(NATIVE_LANGUAGE_COOKIE) private nativeLanguageCookie: string,
    @Inject(WEBAPP_LANGUAGE_COOKIE) private webappLanguageCookie: string,
  ) {}

  /**
   * Update a page to show in the specified language
   */
  switchLanguage(languageCode: string): void {
    this.datastore
      .document<UsersSelfCollection>('usersSelf', this.auth.getUserId())
      .update({
        primaryLanguage: languageCode,
      })
      .then(async () => {
        this.tracking.trackCustomEvent(
          'ChangeLanguageData',
          undefined, // section
          {
            language: languageCode,
          },
        );

        this.cookies.put(
          this.pwa.isNative()
            ? this.nativeLanguageCookie
            : this.webappLanguageCookie,
          languageCode,
        );

        if (this.pwa.getPlatform() === 'ios') {
          await ServiceWorker.switchLanguage({ languageCode });
        } else if (this.pwa.getPlatform() === 'android') {
          // Ref T263064: The Android plugin is named something different, so we need to try both while renaming
          try {
            await ServiceWorkerPlugin.switchLanguage({ languageCode });
          } catch (e) {
            await ServiceWorker.switchLanguage({ languageCode });
          }
        }

        window.location.reload();
      });
  }
}
